import { createEmptyImageDataUrl, loadImage } from "./pdfCanvasImageUtils";
import type { PdfCanvasPageMeta } from "./pdfCanvasTypes";

export async function splitLongImageBase64ToPageDataUrls(
    base64: string,
    pageMetaList: PdfCanvasPageMeta[],
): Promise<string[]> {
    if (!base64 || pageMetaList.length === 0) {
        return pageMetaList.map(e => createEmptyImageDataUrl(e.width, e.height));
    }

    const dataUrl = `data:image/png;base64,${base64}`;
    const longImage = await loadImage(dataUrl);

    const baseWidth = pageMetaList[0]?.width ?? longImage.width;
    const ratio = longImage.width / Math.max(baseWidth, 1);

    let sourceY = 0;
    const initialDataUrls: string[] = [];
    for (const page of pageMetaList) {
        const sourceHeight = page.height * ratio;
        const tempCanvas = document.createElement("canvas");
        tempCanvas.width = page.width;
        tempCanvas.height = page.height;
        const tempCtx = tempCanvas.getContext("2d");
        if (tempCtx) {
            tempCtx.drawImage(longImage, 0, sourceY, longImage.width, sourceHeight, 0, 0, page.width, page.height);
        }
        initialDataUrls.push(tempCanvas.toDataURL("image/png"));
        sourceY += sourceHeight;
    }

    return initialDataUrls;
}
